import styled from '@emotion/styled';
import React, { useMemo } from 'react';
import { Telemetry } from 'core/models/FMS/Telemetry';
import { useTelemetryStatusName } from 'services/useTelemetryStatusName';

const StatusFrame = styled.div({
    width: 'fit-content',
    padding: '2px',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
});

const StatusTitle = styled.div({});

const StatusBody = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    fontFamily: 'Raleway, sans-serif',
    width: '18ex',
});

const StatusCode = styled.div({
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
});

const StatusName = styled.div({
    fontSize: '80%',
});

export function FMSStatus(props: { status: Telemetry.Status | undefined }) {
    const { status } = props;

    const stateStr = useMemo(() => {
        if (!status) return undefined;
        return status.replace(/_/g, ' ');
    }, [status]);
    const name = useTelemetryStatusName(status);

    return <StatusFrame>
        <StatusTitle>Status:&nbsp;</StatusTitle>
        <StatusBody>
            <StatusCode>{stateStr ?? '-'}</StatusCode>
            <StatusName>&nbsp;({name ?? '?'})&nbsp;</StatusName>
        </StatusBody>
    </StatusFrame>;
}
